import { AbstractControl, ControlValueAccessor, ValidationErrors, Validator } from '@angular/forms';
import { ChangeDetectorRef, Directive, EventEmitter, inject, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { isEqual } from 'lodash';

@Directive()
export abstract class FormControlValueAccessorAdapter<T, TForm extends AbstractControl>
  implements ControlValueAccessor, Validator, OnDestroy
{
  public abstract form: TForm;

  private _cdr = inject(ChangeDetectorRef);
  public onTouched: (e?: any) => void = (e) => {};

  protected sub = new Subscription();

  @Output()
  public valueChange = new EventEmitter();

  protected initializeValueChangeSubscription(): void {
    this.sub.add(
      this.form.valueChanges.pipe(distinctUntilChanged(isEqual)).subscribe((value) => {
        this.valueChange.emit(value);
      }),
    );
  }

  public ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  public writeValue(val: any): void {
    if (val !== undefined) {
      this.form.setValue(val, { emitEvent: false });
      this._cdr.markForCheck();
    }
  }

  public registerOnChange(fn: any): void {
    this.sub.add(this.form.valueChanges.pipe(distinctUntilChanged()).subscribe(fn));
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.form.disable() : this.form.enable();
    this._cdr.markForCheck();
  }

  public validate(c: AbstractControl): ValidationErrors | null {
    return this.form.valid
      ? null
      : {
          invalidForm: true,
        };
  }
}
